import Grid from "@material-ui/core/Grid";
import { DPDivider, DPButton } from "Components/DP";
import React from "react";
import {
  initialQueryProps,
} from "Shared/types/EmployeeProfiles";
import isEqual from "lodash/isEqual";
import FilterChips from "./FilterChips/FilterChips";
import SearchResultsText from "./SearchResultsText/SearchResultsText";
import useStyles from "./styles";
import { useEmployeeProfilesQuery } from "Hooks/useEmployeeProfilesQueryContext";
import { useUserFilters, initialUserFiltersState } from "Hooks/useUserFilters";

const SearchResultsInfo = () => {
  const { queryProps } = useEmployeeProfilesQuery();

  const classes = useStyles();
  const { userFilters, resetFilters } = useUserFilters();

  const shouldShowSearchResultsInfo = () => {
    const { search } = queryProps;
    const { search: initialSerach } = initialQueryProps;

    return search !== initialSerach ||
      !isEqual(userFilters, initialUserFiltersState);
  };

  return (
    <>
      <DPDivider margin="condensed" />
      {shouldShowSearchResultsInfo() && (
        <>
          <Grid container justify="space-between">
            <Grid
              container
              className={classes.resultsTextAndChips}
              item
              xs={true}
            >
              <SearchResultsText />
              <FilterChips />
            </Grid>
            <Grid container item className={classes.resetContainer}>
              <DPButton
                variant="text"
                aria-label="Reset"
                className={classes.resetButton}
                onClick={resetFilters}
              >
                Reset
              </DPButton>
            </Grid>
          </Grid>
          <DPDivider className={classes.lowerDivider} margin="condensed" />
        </>
      )}
      <br />
    </>
  );
};

export default SearchResultsInfo;
